import {apiProvider} from "@/services/utilities/Provider";

const remove = (intentId) => {
    return apiProvider.remove("Intent", intentId);
}

const update = (intentId, intent) => {
    return apiProvider.put(`Intent/${intentId}`, intent);
}

const addIntentToScenario = (intent, scenarioId) => {
    return apiProvider.post(`Intent`, {...intent, scenarioId: scenarioId});
}

export default {
    remove,
    update,
    addIntentToScenario
}